import React from 'react';
import ReactTable from 'react-table';
import _ from 'lodash';
import classnames from 'classnames';

import TablePagination from '../Pagination';

class CustomTable extends React.Component {
  render() {
    const { showPageSizeOptions, className, ...rest } = this.props;

    return (
      <ReactTable
        className={classnames( 'app-table -highlight', className )}
        defaultPageSize={20}
        minRows={0}
        pageSizeOptions={[5,10,15,20, 50,100]}
        resizable={false}
        showPaginationBottom={false}
        showPaginationTop
        showPageSizeOptions={_.isUndefined( showPageSizeOptions ) ? true : showPageSizeOptions}
        PaginationComponent={props => <TablePagination {...props} />}
        getTrProps={() => {
          return {
            className: 'pointer'
          };
        }}
        {...rest}
      />
    );
  }
}

export default CustomTable;
